module.exports = __webpack_public_path__ + "static/media/banner.deadbe70.png";